import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { catchError, mergeMap, withLatestFrom } from "rxjs/operators";
import { LoadingService } from "../../loading/loading.service";
import { AcuerdosService } from "../../services/acuerdos/acuerdos.service";
import {
  agregarNuevaEntradaSuccess,
  cargarEntregablesArchivos,
  cargarEntregablesArchivosError,
  cargarEntregablesArchivosSuccess,
  resetTemasAcuerdo,
} from "./actions";

import { MatDialog } from "@angular/material/dialog";
import { AppState, appStore } from "../../app.state";
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
import { IEntregablesArchivosEntrada } from "../../interfaces/acuerdos";
import { off } from "process";
import { selectTipoAcuerdo } from "../acuerdos-mrb/selector";
import { resetAcuerdosByTipo } from "../acuerdos-mrb/actions";
appStore;
@Injectable()
export class TemasEffects {
  constructor(
    private actions$: Actions,
    private acuerdoService: AcuerdosService,
    private store: Store<AppState>,
    private loadingService: LoadingService,
    public dialog: MatDialog
  ) {}

  resetTemasAcuerdo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(resetTemasAcuerdo),
      withLatestFrom(this.store.select(selectTipoAcuerdo)),
      mergeMap(([action, tipoAcuerdo]) => {
        // this.loadingService.show();
        console.log("action", action);
        console.log("tipoAcuerdo", tipoAcuerdo);

        return of(resetAcuerdosByTipo({ tipoAcuerdo }));
      })
    )
  );

  private showDialog(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title: "Atención",
        message: "Favor de capturar todos los datos obligatorios en cada tema.",
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });
  }
}
